import script from "./FlexBubble.vue?vue&type=script&setup=true&lang=js"
export * from "./FlexBubble.vue?vue&type=script&setup=true&lang=js"

import "./FlexBubble.vue?vue&type=style&index=0&id=136c53c9&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-136c53c9"]])

export default __exports__